(function() {
  'use strict';

  /* --- Gallery --- */
  function initGallery() {
    var gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    var mainImages = gallery.querySelectorAll('[data-gallery-img]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var thumbsContainer = gallery.querySelector('[data-gallery-thumbs]');
    var spThumbsContainer = gallery.querySelector('[data-gallery-sp-thumbs]');
    var prevButtons = [
      gallery.querySelector('[data-gallery-scroll="prev"]'),
      gallery.querySelector('[data-gallery-sp-scroll="prev"]')
    ];
    var nextButtons = [
      gallery.querySelector('[data-gallery-scroll="next"]'),
      gallery.querySelector('[data-gallery-sp-scroll="next"]')
    ];
    var current = 0;

    function updateButtons() {
      prevButtons.forEach(function(btn) {
        if (btn) btn.disabled = current <= 0;
      });
      nextButtons.forEach(function(btn) {
        if (btn) btn.disabled = current >= mainImages.length - 1;
      });
    }

    // アクティブなサムネイルが表示領域外の場合のみ、見える位置まで最小限スクロールする
    function scrollActiveThumbIntoView(container, horizontal) {
      if (!container) return;
      var thumb = container.children[current];
      if (!thumb) return;
      var cRect = container.getBoundingClientRect();
      if (horizontal ? cRect.width === 0 : cRect.height === 0) return;
      var tRect = thumb.getBoundingClientRect();
      if (horizontal) {
        if (tRect.left < cRect.left) {
          container.scrollBy({ left: tRect.left - cRect.left, behavior: 'smooth' });
        }
        else if (tRect.right > cRect.right) {
          container.scrollBy({ left: tRect.right - cRect.right, behavior: 'smooth' });
        }
      }
      else {
        if (tRect.top < cRect.top) {
          container.scrollBy({ top: tRect.top - cRect.top, behavior: 'smooth' });
        }
        else if (tRect.bottom > cRect.bottom) {
          container.scrollBy({ top: tRect.bottom - cRect.bottom, behavior: 'smooth' });
        }
      }
    }

    function setActive(index) {
      current = index;
      mainImages.forEach(function(img) {
        img.classList.toggle('product-detail__gallery-main-img--active', img.dataset.galleryImg === String(index));
      });
      thumbs.forEach(function(thumb) {
        var isActive = thumb.dataset.galleryThumb === String(index);
        thumb.classList.toggle('product-detail__gallery-thumb--active', isActive);
        thumb.classList.toggle('product-detail__gallery-sp-thumb--active', isActive);
      });
      updateButtons();
      scrollActiveThumbIntoView(thumbsContainer, false);
      scrollActiveThumbIntoView(spThumbsContainer, true);
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        setActive(parseInt(thumb.dataset.galleryThumb, 10));
      });
    });

    // 前後ボタン: 前/次の商品画像に切り替える
    function stepImage(delta) {
      var index = current + delta;
      if (index < 0 || index >= mainImages.length) return;
      setActive(index);
    }

    prevButtons.forEach(function(btn) {
      if (btn) btn.addEventListener('click', function() { stepImage(-1); });
    });
    nextButtons.forEach(function(btn) {
      if (btn) btn.addEventListener('click', function() { stepImage(1); });
    });

    updateButtons();
  }

  /* --- Cart button state --- */
  function setCartButtonState(available) {
    var btn = document.querySelector('[data-add-to-cart]');
    if (!btn) return;
    btn.disabled = !available;
    btn.classList.toggle('product-detail__cart-btn--soldout', !available);
    var text = btn.querySelector('[data-add-to-cart-text]');
    if (text) text.textContent = available ? 'カートに追加する' : '売り切れ';
    var quantityWrap = document.querySelector('[data-quantity-wrap]');
    if (quantityWrap) quantityWrap.hidden = !available;
  }

  /* --- Variants --- */
  function initVariants() {
    var variantList = document.querySelector('[data-variant-list]');
    if (!variantList) return;

    var items = variantList.querySelectorAll('[data-variant-item]');
    var priceEl = document.querySelector('[data-product-price]');

    items.forEach(function(item) {
      item.addEventListener('click', function() {
        if (item.dataset.variantAvailable === 'false') return;

        items.forEach(function(el) {
          el.classList.remove('product-detail__variant-item--active');
          var radio = el.querySelector('input[type="radio"]');
          if (radio) radio.checked = false;
        });

        item.classList.add('product-detail__variant-item--active');
        var radio = item.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        if (priceEl) {
          priceEl.textContent = item.dataset.variantPrice;
        }

        setCartButtonState(true);

        var url = new URL(window.location);
        url.searchParams.set('variant', item.dataset.variantId);
        window.history.replaceState({}, '', url);
      });
    });
  }

  /* --- Quantity --- */
  function initQuantity() {
    var minusBtn = document.querySelector('[data-quantity-minus]');
    var plusBtn = document.querySelector('[data-quantity-plus]');
    var input = document.querySelector('[data-quantity-input]');
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', function() {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });

    plusBtn.addEventListener('click', function() {
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });

    input.addEventListener('change', function() {
      var val = parseInt(input.value, 10);
      if (!val || val < 1) input.value = 1;
    });
  }

  /* --- Add to Cart --- */
  function initAddToCart() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var errorEl = document.querySelector('[data-cart-error]');

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var btn = form.querySelector('[data-add-to-cart]') || document.querySelector('[data-add-to-cart]');
      if (btn && btn.disabled) return;
      if (btn) {
        btn.disabled = true;
        btn.classList.add('product-detail__cart-btn--loading');
      }
      if (errorEl) errorEl.hidden = true;

      var formData = new FormData(form);
      var data = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function(res) {
          if (!res.ok) {
            return res.json()
              .catch(function() { return {}; })
              .then(function(err) {
                var cartError = new Error('Cart error');
                if (typeof err.description === 'string') cartError.cartMessage = err.description;
                throw cartError;
              });
          }
          return res.json();
        })
        .then(function() {
          window.location.href = '/cart';
        })
        .catch(function(err) {
          showError(err.cartMessage || 'カートに追加できませんでした。時間をおいて再度お試しください。');
          btn.disabled = false;
          btn.classList.remove('product-detail__cart-btn--loading');
        });
    });
  }

  /* --- Recommendations --- */
  function initRecommendations(onDone) {
    var container = document.querySelector('[data-product-recommendations]');
    if (!container) {
      if (onDone) onDone();
      return;
    }

    var productId = container.dataset.productId;
    var grid = container.querySelector('[data-recommendations-grid]');
    if (!productId || !grid) {
      if (onDone) onDone();
      return;
    }

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (!data.products || data.products.length === 0) {
          container.setAttribute('data-empty', '');
          return;
        }
        var html = data.products.map(function(p) {
          var img = p.featured_image
            ? '<img src="' + getSizedImageUrl(p.featured_image, '580x') + '" alt="' + escapeHtml(p.title) + '" width="290" height="290" loading="lazy">'
            : '';
          return '<a href="' + p.url + '" class="product-card">' +
            '<div class="product-card__image">' + img + '</div>' +
            '<p class="product-card__title">' + escapeHtml(p.title) + '</p>' +
            '<p class="product-card__price">' + formatMoney(p.price) + '</p>' +
            '</a>';
        }).join('');
        grid.innerHTML = html;
      })
      .catch(function() {
        container.setAttribute('data-empty', '');
      })
      .finally(function() {
        if (onDone) onDone();
      });
  }

  /* --- Recently Viewed --- */
  var STORAGE_KEY = 'vintique_recently_viewed';
  var MAX_ITEMS = 8;
  var DISPLAY_LIMIT = 4;

  function initRecentlyViewed(onDone) {
    var container = document.querySelector('[data-recently-viewed]');
    if (!container) {
      if (onDone) onDone();
      return;
    }

    var currentHandle = container.dataset.currentHandle;
    saveCurrentProduct(currentHandle);
    loadRecentlyViewed(container, currentHandle, onDone);
  }

  function saveCurrentProduct(handle) {
    if (!handle) return;
    try {
      var items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      items = items.filter(function(h) { return h !== handle; });
      items.unshift(handle);
      if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    }
    catch (e) { /* localStorage unavailable */ }
  }

  function loadRecentlyViewed(container, currentHandle, onDone) {
    var grid = container.querySelector('[data-recently-viewed-grid]');
    if (!grid) {
      if (onDone) onDone();
      return;
    }

    var items;
    try {
      items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    }
    catch (e) {
      if (onDone) onDone();
      return;
    }

    items = items.filter(function(h) { return h !== currentHandle; });
    if (items.length === 0) {
      if (onDone) onDone();
      return;
    }

    var toFetch = items.slice(0, DISPLAY_LIMIT);
    var promises = toFetch.map(function(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function(res) {
          if (!res.ok) return null;
          return res.json();
        })
        .catch(function() { return null; });
    });

    Promise.all(promises).then(function(products) {
      products = products.filter(Boolean);
      if (products.length === 0) return;

      var html = products.map(function(p) {
        var img = p.featured_image
          ? '<img src="' + getSizedImageUrl(p.featured_image, '580x') + '" alt="' + escapeHtml(p.title) + '" width="290" height="290" loading="lazy">'
          : '';
        return '<a href="' + p.url + '" class="product-card">' +
          '<div class="product-card__image">' + img + '</div>' +
          '<p class="product-card__title">' + escapeHtml(p.title) + '</p>' +
          '<p class="product-card__price">' + formatMoney(p.price) + '</p>' +
          '</a>';
      }).join('');

      grid.innerHTML = html;
      container.style.display = '';
      if (onDone) onDone();
    });
  }

  /* --- Helpers --- */
  function formatMoney(cents) {
    return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    var match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?.*)?$/i);
    if (!match) return url;
    var ext = match[0];
    return url.replace(ext, '_' + size + ext);
  }

  /* --- More section visibility --- */
  function checkMoreSectionVisibility() {
    var more = document.querySelector('.product-detail__more');
    if (!more) return;
    var rec = more.querySelector('[data-product-recommendations]');
    var rv = more.querySelector('[data-recently-viewed]');
    var recVisible = rec && !rec.hasAttribute('data-empty') && rec.querySelector('[data-recommendations-grid]').children.length > 0;
    var rvVisible = rv && rv.style.display !== 'none';
    more.style.display = (recVisible || rvVisible) ? '' : 'none';
  }

  /* --- Init --- */
  initGallery();
  initVariants();
  initQuantity();
  initAddToCart();
  initRecommendations(checkMoreSectionVisibility);
  initRecentlyViewed(checkMoreSectionVisibility);
  setTimeout(checkMoreSectionVisibility, 3000);
})();
